// src/pages/misc/landing/contrast/index.tsx
// Contrast-section visuals — the swappable layer for the three pinned No→Yes beats.
//
// HOW TO SWAP: edit CONTRAST_VISUALS below. Each slot is any React component; the page
// never imports visuals directly, it renders <ContrastVisual section="c1" side="no" />.
// To revert a slot to the dashed mockup placeholder, point it at `PlaceholderVisual`.
//
// MOTION CONTRACT (the only bridge to the page's scroll loop):
//   The <section class="vl-pin"> exposes `--vl-swap` (0 → 1, how far the No→Yes swap has
//   progressed) and `data-swap="no|si"`. Visuals animate off those in CSS (contrast.css);
//   nothing here touches the page's pin/scroll logic.
//
// SIZE CONTRACT: every visual fills a fixed-height box (`.vl-cv`, --vl-cv-h) so swapping
// visuals never shifts the section layout.
import React from 'react';
import { AppChaos, BoltOnAi, TenAgents } from './OtherCrmVisuals';
import { AiInsideLead, OneCloser, WorkspaceFicha } from './VentajeVisuals';
import './contrast.css';

export type ContrastSection = 'c1' | 'ia' | 'money';
export type ContrastSide = 'no' | 'si';

/** Original mockup placeholder — keep for quick reverts. */
export const PlaceholderVisual: React.FC<{ label?: string; note?: string }> = ({
  label = 'Placeholder',
  note,
}) => (
  <div className="vl-ph" style={{ minHeight: 0, height: '100%' }}>
    <span className="vl-tag">{label}</span>
    {note && <small>{note}</small>}
  </div>
);

export const CONTRAST_VISUALS: Record<ContrastSection, Record<ContrastSide, React.FC>> = {
  c1: { no: AppChaos, si: WorkspaceFicha },
  ia: { no: BoltOnAi, si: AiInsideLead },
  money: { no: TenAgents, si: OneCloser },
};

export const ContrastVisual: React.FC<{ section: ContrastSection; side: ContrastSide }> = ({
  section,
  side,
}) => {
  const Visual = CONTRAST_VISUALS[section][side];
  return (
    <div className={`vl-cv vl-cv-${side} vl-cv-${section}`} aria-hidden>
      <Visual />
    </div>
  );
};

export default ContrastVisual;
